





























import Vue, { PropType } from 'vue';
import store from '@/store';

import { WebRequestStatus } from '@/models';
import { Outcome, Objective, Usage } from '@/models/packet';
import { IconData } from '@/icons';

import DeleteButtonWithMessage from '@/components/DeleteButtonWithMessage.vue';
import LoadingItem from '@/components/LoadingItem.vue';
import MultiPointObjectiveInput from '@/components/MultiPointObjectiveInput.vue';

export default Vue.extend({
  components: {
    DeleteButtonWithMessage,
    LoadingItem,
    MultiPointObjectiveInput
  },

  props: {
    objective: {
      type: Object as PropType<Objective>,
      required: true
    },
    outcomes: {
      type: Array as PropType<Outcome[]>,
      required: true
    }
  },

  computed: {
    usage(): Usage {
      return store.state.usage.usage;
    },

    canDelete(): boolean {
      return this.usage.userCount === 0;
    },

    deleteStatus(): WebRequestStatus {
      return store.state.usage.status;
    },

    message(): string {
      return (
        `This row cannot be deleted, becasse ${this.objective.name} has been referenced ` +
        'by at least one self-assessment or peer-assessment'
      );
    },

    allowHide(): boolean {
      return this.objective.objectiveId > 0;
    }
  },

  methods: {
    save(fields: { name: string; description: string; iconData: IconData }) {
      this.$emit('save', fields);
    },

    close() {
      this.$emit('close');
    },

    hide() {
      this.$emit('hide');
    },

    deleteObjective() {
      this.$emit('delete', this.objective);
    }
  }
});
